export default function setPageTitle(sectionTitle) {
  document.title = `${sectionTitle} | Checkout | John Lewis & Partners`;
}
